import TemplateRecordEditor from './TemplateRecordEditor.js';
export { emptyBeingTemplate } from './TemplateRecordEditor.js';
export default function BeingTemplateEditor(props) { return <TemplateRecordEditor {...props} kind="Being" />; }
